import { normalize, schema } from 'normalizr';
import { CreatedUserViewModel, UserViewModel } from 'stageclip-common';

import { ById } from '../../store/normalizedState';

import * as EntityNormalizers from './entityNormalizers';

const { Entity } = schema;

export interface NormalizedUsers<T extends UserViewModel = UserViewModel> {
  users: ById<T>;
}

export const userSchema = new Entity('users');

export function normalizeUsers(data: UserViewModel[]): EntityNormalizers.NormalizedEntityArray<NormalizedUsers> {
  return normalize(data, new schema.Array(userSchema));
}

export function normalizeSingleUser(
  data: CreatedUserViewModel,
): EntityNormalizers.NormalizedSingleEntity<NormalizedUsers<CreatedUserViewModel>> {
  return normalize(data, userSchema);
}
